export class Config {
    static api = {
        url: process.env.REACT_APP_RESOURCE_SERVER || 'https://medicheck-backend.azurewebsites.net'
    }
}